import { Tapp } from '../../types/tapp';
import { RootState } from '../rootReducer';

export const getTappsState = (state: RootState): Array<Tapp> => state.tapps;
